module.exports = "/images/mural.jpg?45ba71c13ff7a3fa3d66723e6749b32a";